/* Purchase accordions: ingredient carousel modal and open/close animation. Native <details> work
   without it. Moved out of the page HTML so browsers cache it (speed audit, 15 Oct 2026). */
(function() {
  var root = document.querySelector('.hlth-purchase-accordions');
  if (!root) return;

  /* ---------- Ingredient carousel modal ---------- */
  var tpl = root.querySelector('.hlth-nf-slides-tpl');
  var modal, track, dotsEl, prevBtn, nextBtn, slideCount = 0, currentIdx = 0;

  function buildModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'hlth-nf-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('data-open', 'false');
    modal.innerHTML =
      '<div class="hlth-nf-modal__backdrop" data-nf-close></div>' +
      '<div class="hlth-nf-modal__dialog">' +
        '<button type="button" class="hlth-nf-modal__close" aria-label="Close" data-nf-close>' +
          '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="3" y1="3" x2="13" y2="13"/><line x1="13" y1="3" x2="3" y2="13"/></svg>' +
        '</button>' +
        '<button type="button" class="hlth-nf-modal__nav hlth-nf-modal__nav--prev" aria-label="Previous">' +
          '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="10,3 5,8 10,13"/></svg>' +
        '</button>' +
        '<button type="button" class="hlth-nf-modal__nav hlth-nf-modal__nav--next" aria-label="Next">' +
          '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,3 11,8 6,13"/></svg>' +
        '</button>' +
        '<div class="hlth-nf-modal__viewport"><div class="hlth-nf-modal__track"></div></div>' +
        '<div class="hlth-nf-modal__dots"></div>' +
      '</div>';
    document.body.appendChild(modal);

    track = modal.querySelector('.hlth-nf-modal__track');
    dotsEl = modal.querySelector('.hlth-nf-modal__dots');
    prevBtn = modal.querySelector('.hlth-nf-modal__nav--prev');
    nextBtn = modal.querySelector('.hlth-nf-modal__nav--next');

    if (tpl && tpl.content) {
      track.appendChild(tpl.content.cloneNode(true));
    }
    slideCount = track.children.length;

    // Build dots
    for (var i = 0; i < slideCount; i++) {
      var d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('aria-label', 'Go to ingredient ' + (i + 1));
      d.dataset.dot = i;
      dotsEl.appendChild(d);
    }

    prevBtn.addEventListener('click', function() { goTo(currentIdx - 1); });
    nextBtn.addEventListener('click', function() { goTo(currentIdx + 1); });
    dotsEl.addEventListener('click', function(e) {
      var b = e.target.closest('button[data-dot]');
      if (b) goTo(parseInt(b.dataset.dot, 10));
    });
    modal.addEventListener('click', function(e) {
      if (e.target.closest('[data-nf-close]')) close();
    });
    document.addEventListener('keydown', function(e) {
      if (modal.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') goTo(currentIdx - 1);
      else if (e.key === 'ArrowRight') goTo(currentIdx + 1);
    });

    // Touch swipe
    var startX = 0, dx = 0, dragging = false, width = 0;
    var vp = modal.querySelector('.hlth-nf-modal__viewport');
    vp.addEventListener('touchstart', function(e) {
      dragging = true;
      startX = e.touches[0].clientX;
      width = vp.offsetWidth;
      track.classList.add('is-dragging');
    }, { passive: true });
    vp.addEventListener('touchmove', function(e) {
      if (!dragging) return;
      dx = e.touches[0].clientX - startX;
      track.style.transform = 'translateX(' + (-currentIdx * 100 + (dx / width) * 100) + '%)';
    }, { passive: true });
    vp.addEventListener('touchend', function() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      if (Math.abs(dx) > width * 0.15) {
        goTo(currentIdx + (dx < 0 ? 1 : -1));
      } else {
        goTo(currentIdx);
      }
      dx = 0;
    });
  }

  function goTo(idx) {
    if (idx < 0) idx = 0;
    if (idx > slideCount - 1) idx = slideCount - 1;
    currentIdx = idx;
    track.style.transform = 'translateX(' + (-idx * 100) + '%)';
    var dots = dotsEl.querySelectorAll('button');
    for (var i = 0; i < dots.length; i++) {
      dots[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
    }
    prevBtn.disabled = idx === 0;
    nextBtn.disabled = idx === slideCount - 1;
  }

  function open(idx) {
    buildModal();
    if (!slideCount) return;
    goTo(idx || 0);
    modal.setAttribute('data-open', 'true');
    document.body.classList.add('hlth-nf-modal-open');
  }
  function close() {
    if (!modal) return;
    modal.setAttribute('data-open', 'false');
    document.body.classList.remove('hlth-nf-modal-open');
  }

  root.addEventListener('click', function(e) {
    var item = e.target.closest('.hlth-nf-item');
    if (item && root.contains(item)) {
      if (!item.hasAttribute('data-nf-index')) return;
      e.preventDefault();
      open(parseInt(item.dataset.nfIndex, 10) || 0);
      return;
    }
    var btn = e.target.closest('.hlth-nf-toggle');
    if (!btn || !root.contains(btn)) return;
    e.preventDefault();
    e.stopPropagation();
    var target = document.getElementById(btn.getAttribute('aria-controls'));
    if (!target) return;
    // Inject the image on first open (deferred load — zero network until clicked)
    if (!target.firstElementChild && target.dataset.src) {
      var img = new Image();
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = target.dataset.alt || '';
      if (target.dataset.width) img.width = target.dataset.width;
      if (target.dataset.height) img.height = target.dataset.height;
      if (target.dataset.srcset) img.srcset = target.dataset.srcset;
      img.sizes = '(min-width: 750px) 600px, 100vw';
      img.src = target.dataset.src;
      target.appendChild(img);
    }
    var isOpen = target.getAttribute('data-open') === 'true';
    target.setAttribute('data-open', isOpen ? 'false' : 'true');
    btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    if (!btn.dataset.labelShow) btn.dataset.labelShow = btn.textContent.trim();
    btn.textContent = isOpen ? btn.dataset.labelShow : (btn.dataset.labelHide || 'Hide Full Facts');
    var det = btn.closest('details');
    if (det && det.open) {
      var inner = det.querySelector('.hlth-accordion-inner');
      if (inner) inner.style.height = 'auto';
    }
  });
})();
(function() {
  var wrap = document.querySelector('.hlth-purchase-accordions');
  if (!wrap) return;
  var ANIMATION_TIMEOUT = 600; // fallback ms in case transitionend never fires

  wrap.querySelectorAll('details').forEach(function(det) {
    var summary = det.querySelector('summary');
    var inner = det.querySelector('.hlth-accordion-inner');
    if (!summary || !inner) return;

    // Stagger delay helper for list items
    function staggerItems(det, show) {
      var items = det.querySelectorAll('.hlth-seed-list li');
      items.forEach(function(li, i) {
        li.style.transitionDelay = show ? (i * 50) + 'ms' : '0ms';
      });
      if (show) {
        // Clear delays after animation completes so close is instant
        setTimeout(function() {
          items.forEach(function(li) { li.style.transitionDelay = '0ms'; });
        }, items.length * 50 + 300);
      }
    }

    // Initialize already-open details so close animation works
    if (det.open) {
      inner.style.height = 'auto';
      inner.style.opacity = '1';
      det.classList.add('is-open');
    }

    summary.addEventListener('click', function(e) {
      e.preventDefault();
      if (det.classList.contains('is-animating')) return;
      det.classList.add('is-animating');

      if (det.open) {
        // Closing — remove stagger class immediately
        det.classList.remove('is-open');
        staggerItems(det, false);
        inner.style.height = inner.scrollHeight + 'px';
        inner.offsetHeight; // force reflow
        inner.style.height = '0';
        inner.style.opacity = '0';

        var closeDone = false;
        var closeTimeout = setTimeout(function() {
          if (closeDone) return;
          closeDone = true;
          det.open = false;
          det.classList.remove('is-animating');
        }, ANIMATION_TIMEOUT);

        inner.addEventListener('transitionend', function handler(ev) {
          if (ev.propertyName !== 'height') return;
          inner.removeEventListener('transitionend', handler);
          if (closeDone) return;
          closeDone = true;
          clearTimeout(closeTimeout);
          det.open = false;
          det.classList.remove('is-animating');
        });
      } else {
        // Opening — stagger list items in
        det.open = true;
        var h = inner.scrollHeight;
        inner.style.height = '0';
        inner.offsetHeight; // force reflow
        inner.style.height = h + 'px';
        inner.style.opacity = '1';
        staggerItems(det, true);
        det.classList.add('is-open');

        var openDone = false;
        var openTimeout = setTimeout(function() {
          if (openDone) return;
          openDone = true;
          inner.style.height = 'auto';
          det.classList.remove('is-animating');
        }, ANIMATION_TIMEOUT);

        inner.addEventListener('transitionend', function handler(ev) {
          if (ev.propertyName !== 'height') return;
          inner.removeEventListener('transitionend', handler);
          if (openDone) return;
          openDone = true;
          clearTimeout(openTimeout);
          inner.style.height = 'auto';
          det.classList.remove('is-animating');
        });
      }
    });
  });
})();
